import React from 'react'
import { dispatch } from '@rematch/core';
import { Button, Header, Modal, Grid, Icon } from 'semantic-ui-react';
import LoadingComponent from "../../../../common/LoadingComponent";
import { toastr } from 'react-redux-toastr';

class CreatePlaybookModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            processing: false
        };
        this.fileUploaded = this.fileUploaded.bind(this);
    }

    async fileUploaded(data) {
        if (data.target.files[0].name.split('.').pop() === 'playbook') {
            this.setState({ processing: true })
            var fileToLoad = data.target.files[0];
            let selectedOrganisation = this.props.selectedOrganisation;
            this.props.closeModal();
            const stopLoader = () => {
                this.setState({ processing: false });
            }
            var fileReader = new FileReader();

            fileReader.onload = async (fileLoadedEvent) => {
                if (fileLoadedEvent.currentTarget.result === '') {
                    toastr.error('Message', 'Invalid File.');
                    stopLoader();
                    return;
                }
                if (fileLoadedEvent.target.result !== "undefined") {
                    await dispatch.lifeCycle.importPlaybook({
                        data: fileLoadedEvent.target.result,
                        accountId: this.props.accountId,
                        organizationId: this.props.organizationId
                    });
                    //   stopLoader();
                } else {
                    toastr.error('Message', 'Invalid File.');
                    stopLoader();
                }

            };

            fileReader.readAsText(fileToLoad, "UTF-8");
        } else {
            toastr.error('Message', 'Invalid File.');
        }
    }


    render() {
        const inlineStyle = {
            modal: {
                marginTop: '0px !important',
                marginLeft: 'auto',
                marginRight: 'auto'
            }
        };
        return (
            <div>
                <LoadingComponent active={this.state.processing} message="Creating Playbook" />
                <Modal
                    style={inlineStyle.modal}
                    open={this.props.showNewPlaybookModal}
                    onClose={this.props.closeModal}
                    size='mini'
                    closeOnEscape={false}
                    closeOnDimmerClick={false}
                >
                    <Header content={"Add Playbook"} />

                    <Modal.Content style={{ 'padding': '0 15px' }}>

                        <Grid centered className="cssFileInput">
                            <Grid.Row>
                                <Grid.Column width={8}>
                                    <Button id="create" onClick={this.props.createPack}>
                                        <label className="createPlaybook">
                                            <Icon name="plus" />
                                            <div>Create Playbook</div>
                                        </label>
                                    </Button>
                                </Grid.Column>
                                <Grid.Column width={8}>
                                    <input type="file" name="file1" id="file1" className="inputfile" onChange={this.fileUploaded} accept=".playbook" />
                                    <label className="importPlaybook" htmlFor="file1">
                                        <Icon name="folder open" />
                                        <div>Import Playbook</div>
                                    </label>
                                </Grid.Column>
                            </Grid.Row>


                        </Grid>


                    </Modal.Content>
                    <Modal.Actions className="actionInFormcy">
                        <Button
                            id='cancelBtn'
                            type="button"
                            className="button-cancel"
                            onClick={this.props.closeModal}> Cancel
                        </Button>

                    </Modal.Actions>
                </Modal>
            </div>
        )
    }
}

export default CreatePlaybookModal